<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-gift"></i> The Guide to Governance Law-PF, ESIC, Gratuity</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->
        

             <div class="row row-replace m-t-30">
                 <div class="col-md-12">
                       <p> <a target="blank" href="https://www.aparajitha.com/contact-us.html">https://www.aparajitha.com/contact-us.html</a></p> 
                       <p>- Pls login compfielaw.com</p>
                       <p>- Click legislations</p>
                       <p>- Select required Central / State / Act / Rules</p>
                       <p>- Select particular Act / rules</p>
                       <p>- Select Read Full Act</p>
                </div>
            </div>
                

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

